import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { HotelListFiltersKeyValueViewModel } from '@api/v3';

const DesktopRegionFilter = dynamic(() => import('./DesktopRegionFilter'));
const MobileRegionFilter = dynamic(() => import('./MobileRegionFilter'));

interface Props {
  title?: string;
  totalItemCount?: number;
  regions?: HotelListFiltersKeyValueViewModel[];
  onCheck: (checkedKeysValue: any, e: any) => void;
  isLoading?: boolean;
  isError?: boolean;
  selectedRegions?: Array<any>;
  isCity?: boolean;
}

const RegionFilter = ({
  title,
  totalItemCount,
  regions,
  isLoading,
  onCheck,
  isError,
  selectedRegions,
  isCity,
}: Props) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <DesktopRegionFilter
      title={title}
      totalItemCount={totalItemCount}
      regions={regions}
      onCheck={onCheck}
      selectedRegions={selectedRegions}
      isLoading={isLoading}
      isError={isError}
      isCity={isCity}
    />
  ) : (
    <MobileRegionFilter
      regions={regions}
      onCheck={onCheck}
      isLoading={isLoading}
      isError={isError}
      selectedRegions={selectedRegions}
      isCity={isCity}
    />
  );
};

export default RegionFilter;
